import React from "react";
import logoImg from "../assets/LOGO.png";

/**
 * Official Brand Logo Component for S.K. Woollens
 * Displays the golden ram hallmark emblem and verified brand typography.
 * Ensures "S.K. WOOLLENS" remains on a single unbroken horizontal line across all viewports.
 */
const Logo = ({ className = "h-8 sm:h-9 md:h-10", variant = "full", light = false }) => {
  const textColorClass = light ? "text-white" : "text-wool-charcoal";

  // Dedicated emblem badge
  const emblemBadge = (
    <div
      className={`relative shrink-0 overflow-hidden rounded-lg shadow-sm border ${
        light ? "border-white/20 shadow-black/40" : "border-emerald-950/20 shadow-emerald-950/10"
      } bg-[#233528] flex items-center justify-center transition-transform duration-300 group-hover:scale-105`}
    >
      <img
        src={logoImg}
        alt="S.K. Woollens Official Hallmark"
        className={`${className} w-auto object-contain select-none`}
        loading="eager"
      />
    </div>
  );

  if (variant === "icon" || variant === "badge") {
    return emblemBadge;
  }

  return (
    <div className="flex items-center gap-2 sm:gap-2.5 select-none min-w-0">
      {emblemBadge}

      {variant === "full" && (
        <div className="flex flex-col justify-center leading-tight min-w-0">
          {/* Main Brand Title - Always single line without wrapping */}
          <div className="flex items-center gap-1.5 whitespace-nowrap">
            <span
              className={`font-display font-extrabold tracking-wider text-[13px] xs:text-sm sm:text-base md:text-lg uppercase whitespace-nowrap ${textColorClass}`}
            >
              S.K. WOOLLENS
            </span>
            <span
              className={`hidden md:inline-block text-[9px] font-bold tracking-wider uppercase px-1.5 py-0.5 rounded whitespace-nowrap ${
                light
                  ? "bg-white/10 text-wool-sand"
                  : "bg-wool-sand text-wool-bronze-dark"
              }`}
            >
              Est. 1965
            </span>
          </div>

          {/* Subtitle - Care of Bulakichand Kesharichand on single line */}
          <span
            className={`text-[9px] xs:text-[10px] sm:text-[11px] font-medium tracking-normal whitespace-nowrap truncate max-w-[150px] xs:max-w-[200px] sm:max-w-none ${
              light ? "text-wool-sand/80" : "text-wool-slate"
            }`}
          >
            Care of Bulakichand Kesharichand
          </span>
        </div>
      )}

      {variant === "horizontal" && (
        <span
          className={`font-display font-bold tracking-widest text-sm sm:text-lg md:text-xl uppercase whitespace-nowrap ${textColorClass}`}
        >
          S.K. WOOLLENS
        </span>
      )}
    </div>
  );
};

export default Logo;
